import React from 'react';
import { Card, CardContent } from './ui/card';

const SpeakerCard = ({ speaker }) => {
  return (
    <Card className="overflow-hidden border-none shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group">
      <div className="relative h-80 overflow-hidden">
        <img 
          src={speaker.image} 
          alt={speaker.name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
          <h3 className="text-2xl font-bold mb-1">{speaker.name}</h3>
          <p className="text-[#d97706] font-semibold mb-2">{speaker.title}</p>
        </div>
      </div>
      <CardContent className="p-6">
        <p className="text-gray-600 leading-relaxed">{speaker.bio}</p>
      </CardContent>
    </Card>
  );
};

export default SpeakerCard;
